export const CustomFields = {
  CheckboxWithHtml: '{A4072DE6-9419-4049-99BD-4175A24FF5D7}',
  DropdownListWithEvents: '{DF654370-7A56-4C1A-AED1-EDAFD3DE4D0E}',
  Hidden: '{3A07ABF0-2EBA-473C-8AF7-51D61D2F18C4}',
  MemberId: '{B69A5B9D-6B26-44C1-8DE7-8263DF9B3C04}',
  Recaptcha: '{6ABDE06F-C050-4829-BADE-BAC444F19191}',
  RichText: '{6A34FF0C-095B-4B6C-92DD-45464660F8E1}',
  SingleLineTextWithEvents: '{0BC3D2E9-9B41-4134-96A9-7E9BE37B1CA0}',
  SubmitButton: '{7CE25CAB-EF3A-4F73-AB13-D33BDC1E4EE2}',
};

export default CustomFields;
